export default __webpack_public_path__ + "static/media/getInTouch.885a1d97.png";